import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-bi-reference-single-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/single-select-search-control.component.html",
    providers: [
        registerSearchControl(ReferenceSingleSelectSearchControlComponent)
    ]
})
export class ReferenceSingleSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.bi.search.option.reference.average", value: "average"},
            {label: "wbo.bi.search.option.reference.yago", value: "yago"},
            {label: "wbo.bi.search.option.reference.mago", value: "mago"},
            {label: "wbo.bi.search.option.reference.wago", value: "wago"}
        ]);
    }
}
